import React from "react";
import {
  Grid,
  TextField,
  IconButton,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const OptionInput = ({ option, index, onChange, onRemove, totalOptions }) => {
  return (
    <Paper sx={{ p: 2, mb: 1, backgroundColor: "white" }} elevation={1}>
      <Grid container spacing={2} alignItems="center">
        {/* Option Text */}
        <Grid item xs={12} md={5}>
          <TextField
            label={`Option ${index + 1}`}
            value={option.option_text}
            onChange={(e) => onChange(index, "option_text", e.target.value)}
            size="small"
            fullWidth
          />
        </Grid>

        {/* Sort Order Dropdown */}
        <Grid item xs={6} md={2}>
          <TextField
            select
            label="Sort Order"
            value={option.sort_order || index + 1}
            onChange={(e) =>
              onChange(index, "sort_order", Number(e.target.value))
            }
            size="small"
            fullWidth
          >
            {[...Array(totalOptions + 5)].map((_, i) => (
              <MenuItem key={i} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Correct Checkbox */}
        <Grid item xs={6} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={option.is_correct}
                onChange={(e) =>
                  onChange(index, "is_correct", e.target.checked)
                }
              />
            }
            label="Correct"
          />
        </Grid>

        {/* Delete Button */}
        <Grid item xs={12} md={2}>
          <IconButton onClick={() => onRemove(index)} color="error">
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OptionInput;
